





























import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { EmoticonEntity } from '@/entities/emoticon.entity';
import { mapActions, mapGetters } from 'vuex';
import IssueCommentReactionService from '@/services/issue-comment-reaction.service';
import IssueReactionService from '@/services/issue-reaction.service';
import ReactionIcon from '@/components/Helper/Icon/Svg/ReactionIcon.vue';

@Component<AddReactionButton>({
  components: { ReactionIcon },
  computed: {
    ...mapGetters('emoticon', ['emoticons']),
  },
  methods: {
    ...mapActions('emoticon', ['fetchEmoticons']),
  },
})
export default class AddReactionButton extends Vue {
  emoticons!: EmoticonEntity[];
  fetchEmoticons!: () => Promise<void>;

  @Prop()
  service: IssueCommentReactionService | IssueReactionService;

  @Prop({ type: [String, Number] })
  commentId: string | number;

  @Prop({ type: [String, Number] })
  issueId: string | number;

  async mounted() {
    if (this.emoticons.length === 0) {
      await this.fetchEmoticons();
    }
  }

  async createReaction(id: number) {
    if (this.service instanceof IssueCommentReactionService) {
      await this.service.createOne({
        emoticonId: id,
        commentId: this.commentId as number,
      });
    } else {
      await this.service.createOne({
        emoticonId: id,
        issueId: this.issueId as number,
      });
    }
  }
}
